// containers/TotalSalesMonth.jsx
import React, { useEffect, useState } from "react";
import AverageCountSales30DaysDisplay from "../../components/VentasDatos/AverageCountSales30DaysDisplay";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function AverageCountSales30Days() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchTotal = async () => {
      const user = getUser();
      try {
        const res = await fetch(
          `${URL}/api/sales/datos/summary/average-sales-count-30-days/`,
          {
            headers: {
              "x-empresa-id": user?.empresa_id,
            },
          }
        );
        if (!res.ok) throw new Error("Error al obtener el promedio de la cantidad de ventas por dia");
        const data = await res.json();
        setTotal(data.average_sales_per_day);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTotal();
  }, []);

  return <AverageCountSales30DaysDisplay total={total} />;
}
